export class ServicoModel {
    
    nuServico: string;
    deServico: string;
   
}
